export const weightLossFoodNames = [
    'apple',
    'artichoke',
    'asparagus',
    'beet greens',
    'blackberries',
    'bok choy',
    'broccoli',
    'brussels sprouts',
    'cabbage',
    'cauliflower',
    'celery',
    'chicken breast',
    'chicory',
    'crab',
    'cucumber',
    'eggs',
    'edamame',
    'fennel',
    'filet mignon',
    'grapefruit',
    'green beans',
    'kale',
    'lean pork loin',
    'lean steak',
    'lettuce',
    'onion',
    'orange',
    'raspberries',
    'roast beef',
    'sashimi tuna',
    'shrimp',
    'spaghetti squash',
    'spinach',
    'strawberries',
    'summer squash',
    'swiss chard',
    'tofu',
    'tomato',
    'turkey breast',
    'white tuna fish',
    'white fish',
    'zucchini',
];
export const beverageNames = [
    'almond milk',
    'coconut milk',
    'coffee',
    'energy drink',
    'cream',
    'juice',
    'lemonade',
    'milk',
    'oat milk',
    'seltzer water',
    'soft drink',
    'soy milk',
    'tea',
];
